export var prototypeAdditions;
(function (prototypeAdditions) {
    function __defineEmbeddedComponents() {
        this.__embeddedComponents = [];
    }
    prototypeAdditions.__defineEmbeddedComponents = __defineEmbeddedComponents;
    function __addEmbeddedComponent(component) {
        this.__embeddedComponents.push(component);
        if (this.__componentState === 'attached') {
            component.hasBeenAttached();
        }
    }
    prototypeAdditions.__addEmbeddedComponent = __addEmbeddedComponent;
    function __attachEmbeddedComponents() {
        this.__embeddedComponents.forEach(function (component) { return component.hasBeenAttached(); });
    }
    prototypeAdditions.__attachEmbeddedComponents = __attachEmbeddedComponents;
    function __removeEmbeddedComponent(component) {
        var index = this.__embeddedComponents.indexOf(component);
        this.__embeddedComponents.splice(index, 1);
    }
    prototypeAdditions.__removeEmbeddedComponent = __removeEmbeddedComponent;
})(prototypeAdditions || (prototypeAdditions = {}));
export function extendComponent(customPrototype, definition) { }
//# sourceMappingURL=EmbeddedComponentsHandling.js.map